<app-parameter-card [title]="title">
  <div class="container">
    <div class="pills top" *ngIf="parameterData.data.actionMessage">{{parameterData.data.actionMessage}}</div>
    <mat-slider class="twikit-mat-slider"
                [min]="0"
                [max]="parameterData.options.length - 1"
                [step]="1"
                [value]="getSelectedIndexOfValue()"
                (input)="value$.next(parameterData.options[$event.value])"
    ></mat-slider>
    <div class="pills">
      <div class="pill-left">{{ parameterData.options[0].name }}</div>
      <div class="pill-right">{{ parameterData.options[parameterData.options.length - 1].name }}</div>
    </div>
  </div>
</app-parameter-card>
